import dayjs from 'dayjs'
import { cloneDeep } from 'lodash'
import { idCardBringOutFieldsConfig } from '../addOrEditDialogForm.js'
import { verifyDate } from '../../../../../../../utils/common.js'
import { dealWithSearchResultParams } from './util.js'
import {
    queryDriverInfo,
    checkSupplierIsWhite,
    checkDriverIsExists,
    checkDriverIsExistsByEdit,
    getOnWayContacts,
} from '../../../../../../../api/register/driver.js'
import { getSysControlParamList } from '../../../../../../../api/toDo/sysParamsConfig.js'
import { getCitys, getCountrys, getProvinces } from '../../../../../../../utils/getArea.js'
import {
    AUDIT_STATUS,
    LOGISTICS_SUPPLIER,
    DATE_FOREVER,
    REGISTER_SOURCE,
    ON_WAY_CONTACT_CGR,
} from '../../../../../../../constant/constant.js'
import { DELEGATE_TYPE } from './config.js'
export const INIT_OCR_RESULT_MAP = {
    idCardFileUrl: {
        fieldName: 'idCardFileUrl',
        imageStatus: '',
        riskType: '',
        editTool: '',
        classificationNumber: 0, //当前证件的分类识别调用次数
        classificationErrorNumber: 0, //当前证件的分类识别错误次数
        continueUseNumber: 0, //当前证件选择继续使用的次数
        isUseError: '0',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    idCardBottomSideFileUrl: {
        fieldName: 'idCardBottomSideFileUrl',
        imageStatus: '',
        riskType: '',
        editTool: '',
        classificationNumber: 0, //当前证件的分类识别调用次数
        classificationErrorNumber: 0, //当前证件的分类识别错误次数
        continueUseNumber: 0, //当前证件选择继续使用的次数
        isUseError: '0',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    drivingLicenceFileUrl: {
        fieldName: 'drivingLicenceFileUrl',
        warnInfos: '',
        riskType: '',
        editTool: '',
        classificationNumber: 0, //当前证件的分类识别调用次数
        classificationErrorNumber: 0, //当前证件的分类识别错误次数
        continueUseNumber: 0, //当前证件选择继续使用的次数
        isUseError: '0',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    empCertificateFileUrl: {
        fieldName: 'empCertificateFileUrl',
        warnInfos: '',
        riskType: '',
        editTool: '',
        classificationNumber: 0, //当前证件的分类识别调用次数
        classificationErrorNumber: 0, //当前证件的分类识别错误次数
        continueUseNumber: 0, //当前证件选择继续使用的次数
        isUseError: '0',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    idCardEndDate: {
        fieldName: 'idCardEndDate',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    phoneNo: {
        fieldName: 'phoneNo',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    empCertificateEndDate: {
        fieldName: 'empCertificateEndDate',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    driverName: {
        fieldName: 'driverName',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    idCard: {
        fieldName: 'idCard',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    idCardStartDate: {
        fieldName: 'idCardStartDate',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    drivingLicence: {
        fieldName: 'drivingLicence',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    driveType: {
        fieldName: 'driveType',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    driveStartDate: {
        fieldName: 'driveStartDate',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    driveEndDate: {
        fieldName: 'driveEndDate',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    empCertificate: {
        fieldName: 'empCertificate',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    delegateFileUrl: {
        fieldName: 'delegateFileUrl',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    delegateStartTime: {
        fieldName: 'delegateStartTime',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    delegateEndTime: {
        fieldName: 'delegateEndTime',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    empCertificateType: {
        fieldName: 'empCertificateType',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    dateIssue: {
        fieldName: 'dateIssue',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    driverLicenseAuthority: {
        fieldName: 'driverLicenseAuthority',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    countryCode: {
        fieldName: 'countryCode',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    countryName: {
        fieldName: 'countryName',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    provinceName: {
        fieldName: 'provinceName',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    cityName: {
        fieldName: 'cityName',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    familyAddress: {
        fieldName: 'familyAddress',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    onWayContactCategory: {
        fieldName: 'onWayContactCategory',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    onWayContactName: {
        fieldName: 'onWayContactName',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    onWayContactPhone: {
        fieldName: 'onWayContactPhone',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    stamperName: {
        fieldName: 'stamperName',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    stamperMobile: {
        fieldName: 'stamperMobile',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
}
export default {
    // 初始化数据
    initFormData(data) {
        //获取AB准驾车型时从业资格证卡控阻断开关
        getSysControlParamList({ controlCode: 'driver_emp_certificate_strong_control' }).then(res => {
            this.empSwitch = res && +res.code === 0 && res.data.list && res.data.list[0] && res.data.list[0].controlValue === 'true'
        })
        this.ocrResultMap = cloneDeep(INIT_OCR_RESULT_MAP)
        if(['30', '80'].includes(data.approvalStatus) && data.paramFieldList && data.paramFieldList.length){
            //如果是撤回/驳回状态，需要取paramFieldList赋值，防止再次原封不动提交出现免审的情况
            const obj = data.paramFieldList.reduce((t,v) => {
                t[v.fieldName] = cloneDeep(v)
                return t
            }, {})
            this.ocrResultMap = {
                ...this.ocrResultMap,
                ...obj,
            }
        }
        //重置ocr图片质量欠佳提示次数
        this.ocrQualityCount = {
            idCardFileUrl: 0,
            idCardBottomSideFileUrl: 0,
            drivingLicenceFileUrl: 0,
            empCertificateFileUrl: 0,
        }
        Object.keys(data).forEach(k => {
            // 接口返回了 YYYY-MM-DD 00:00:00 格式，需要转换成YYYY-MM-DD，否则与ocrData作对比会有差异
            if (
                [
                    'idCardStartDate',
                    'idCardEndDate',
                    'driveStartDate',
                    'driveEndDate',
                    'delegateStartTime',
                    'delegateEndTime',
                    'empCertificateEndDate',
                    'dateIssue',
                ].includes(k)
                && data[k]
            ) {
                this.formData[k] = dayjs(data[k]).format('YYYY-MM-DD')
            } 
            // else if (['empCertificateType'].includes(k)) {
            //     this.formData[k] = data[k] && typeof data[k] === 'string' ? data[k].split(',') : []
            // } 
            else if (k === 'onWayContactCategory' && !this.id) {
                this.formData.onWayContactCategory = this.isLgtPptSup
                    ? ON_WAY_CONTACT_CGR.SUPPLIER
                    : this.isLgtPsSup
                        ? ON_WAY_CONTACT_CGR.DRIVER
                        : ''
            } else {
                this.formData[k] = data[k]
            }
        })
        this.delegateOnline = data.delegateOnline

        this.setFileData(data)
        this.driverInfo.idCard = this.formData.idCard
        this.driverInfo.phoneNo = this.formData.phoneNo
        // 暂存 身份证起始日期、到期日期、附件，驾驶证起始日期、到期日期、附件，编辑提交时作校验
        this.driverInfo.idCardStartDate = this.formData.idCardStartDate
        this.driverInfo.idCardEndDate = this.formData.idCardEndDate
        this.driverInfo.idCardBottomSideFileUrl = this.formData.idCardBottomSideFileUrl
        this.driverInfo.driveStartDate = this.formData.driveStartDate
        this.driverInfo.driveEndDate = this.formData.driveEndDate
        this.driverInfo.drivingLicenceFileUrl = this.formData.drivingLicenceFileUrl
        // 暂存 委派函相关字段值，用于判断 签署方式 是否置灰
        this.driverInfo.stamperCode = this.formData.stamperCode
        this.driverInfo.delegateStartTime = this.formData.delegateStartTime
        this.driverInfo.delegateEndTime = this.formData.delegateEndTime
        this.driverInfo.pushType = this.formData.pushType
        this.$nextTick(() => {
            this.$refs.formRef.clearValidate()
        })
        getCountrys().then(res => {
            this.countryOptions = [].concat(res)
        })
        this.setPrivinceCityOptions()
        // 根据是否法人初始化委派函
        if (this.isLegalPersonSupplier) {
            this.setDelegateOlVisible()
        }
        // 根据是否法人设置从业资格证必填
        // const empIndex = this.uploadList.findIndex(item => item.fileUrl === 'empCertificateFileUrl')
        // this.uploadList[empIndex].isRequired = !this.isLegalPersonSupplier
        // 将初始化数据赋予ORC识别的暂存对象
        Object.keys(this.ocrData).forEach(k => {
            this.ocrData[k] = this.formData[k]
        })

        // 物流法人供应商在进行新增操作时，填充在途联系人相关字段
        if (!this.id && this.isLgtPptSup) {
            this.setOnWayContact('system')
        }
        //备份表单字段用于编辑提交时比对校验
        this.backupFormData = JSON.parse(JSON.stringify(this.formData))
        this.showAbnormalFlag = {
            drivingLicenceFileUrl: this.formData.abnormalFlag ? this.formData.abnormalFlag.indexOf('1') > -1 : false,
            empCertificateFileUrl: this.formData.abnormalFlag ? this.formData.abnormalFlag.indexOf('2') > -1 : false,
            idCardFileUrl: this.formData.abnormalFlag ? this.formData.abnormalFlag.indexOf('3') > -1 : false,
            idCardBottomSideFileUrl: this.formData.abnormalFlag ? this.formData.abnormalFlag.indexOf('3') > -1 : false,
        }
    },
    // 将证件信息(fileId, fileName, fileUrl)存储下来
    setFileData(data) {
        ['idCardFile', 'idCardBottomSideFile', 'drivingLicenceFile', 'empCertificateFile'].forEach(k => {
            this.uploadForm[`${k}Url`] = data[`${k}TemUrl`] || data[`${k}Url`] || this.formData[`${k}Url`]
            this.fileObj[`${k}Url`] = {
                id: data[`${k}Id`] || this.formData[`${k}Id`],
                localFileName: data[`${k}Name`] || this.formData[`${k}Name`],
                downUrl: data[`${k}TemUrl`] || data[`${k}Url`] || this.formData[`${k}Url`],
            }
        })
    },
    async getControlSwitch(controlCode, prop){
        await getSysControlParamList({ controlCode }).then(res => {
            if (res && +res.code === 0 && res.data.list && res.data.list[0]) {
                this[prop] = res.data.list[0].controlValue === 'true'
            }
        })
    },
    delFile(key){
        this.formData[`${key}Url`] = ''
        this.formData[`${key}Name`] = ''
        this.formData[`${key}Id`] = ''
        this.uploadForm[`${key}Url`] = ''
        this.fileObj[`${key}Url`] = {id: '', localFileName: '', downUrl: ''}
        //当有异常标识时,删除文件需要把异常标识清空
        this.showAbnormalFlag[`${key}Url`] = false
        if(key === 'empCertificateFile'){
            //从业资格证删除时，需要将相关信息清空
            this.formData.empCertificate = ''
            this.formData.empCertificateEndDate = ''
            this.formData.empCertificateType = ''
            this.$nextTick(() => {
                this.$refs['formRef'].clearValidate('empCertificateEndDate')
            })
        }
    },
    aiCounter(type, counter){
        const url = type.split('#')[1]
        if(this.ocrResultMap[url]) {
            this.ocrResultMap[url][counter]++
        }
    },
    // 文件上传成功后回调
    async handleUploadSuccess(result) {
        const name = result.flag.split('#')[0]
        const url = result.flag.split('#')[1]
        const id = result.flag.split('#')[2]
        const ocrResult = result.data.ocrResult
        const responseData = result.data.ossResult ? result.data.ossResult : result.data.data
        if(result.aiFlag){
            //原来需要ocr的证件因为ai识别有异常，用户选择了普通上传，不走ocr
        }else{
            if(!ocrResult && ['idCardFileUrl', 'idCardBottomSideFileUrl', 'drivingLicenceFileUrl', 'empCertificateFileUrl'].includes(url) && this.ocrQualityCount[url] < 3){
                //ocr接口报错，也需要累加ocrQualityCount次数
                this.ocrQualityCount[url] += 1
                this.$message.warning(`证件OCR失败，请重新上传图片`)
                return
            }
    
            //OCR识别当图片质量有问题时，记录次数，前3次不允许上传
            //图片质量问题：身份证----image_status≠normal
            //判断是走老OCR还是新OCR：risk_type字段undefined为老OCR,老OCR不需要校验图片质量问题与risk_type
            const qualityFlag = ocrResult && (['idCardFileUrl', 'idCardBottomSideFileUrl'].includes(url) && ocrResult.image_status !== 'normal') && ocrResult.risk_type !== undefined
            if(ocrResult && qualityFlag && this.ocrQualityCount[url] < 3){
                this.ocrQualityCount[url] += 1
                if(['idCardFileUrl', 'idCardBottomSideFileUrl'].includes(url)){
                    switch(ocrResult.image_status){
                        case 'reversed_side':
                            this.$message.warning(`上传的图片不是身份证${url === 'idCardFileUrl' ? '人像面' : '国徽页'}，请重新上传。`)
                            break
                        case 'non_idcard':
                        case 'other_type_card':
                            this.$message.warning(`上传的不是身份证，请重新上传。`)
                            break
                        case 'blurred':
                        case 'over_exposure':
                        case 'over_dark':
                        case 'unknown':
                            this.$message.warning(`上传的证件模糊或图片不齐全，请重新上传。`)
                            break
                    }
                }else{
                    this.$message.warning(`上传的证件模糊或图片不齐全，请重新上传。`)
                }
                return
            }

            //驾驶证图片edit_tool有值，图片存在编辑过的风险，需要卡控
            if(ocrResult && ['drivingLicenceFileUrl'].includes(url) && ocrResult.edit_tool){
                await this.getControlSwitch('ocrUploadEditTool', 'editToolSwitch')
                this.$message.warning(this.editToolSwitch ? `上传的图片存在被编辑过的风险，请重新上传。` : `上传的图片可能存在被编辑过的风险，请注意。`)
                if(this.editToolSwitch) {
                    //开关打开
                    return 
                }
            }
    
            //当身份证risk_type=unknown,ocrUploadRiskType开关开启时阻断赋值，关闭时仅提示仍允许赋值
            if(ocrResult && ocrResult.risk_type === 'unknown' && ['idCardFileUrl', 'idCardBottomSideFileUrl'].includes(url)){
                await this.getControlSwitch('ocrUploadRiskType', 'riskTypeSwitch')
                this.$message.warning(this.riskTypeSwitch ? `上传的图片不符合合规要求，请重新上传。` : `上传的图片不符合合规要求，请注意风险。`)
                if(this.riskTypeSwitch) {
                    //开关打开
                    return 
                }
            }
            
        }

        if(this.ocrResultMap[url]) {
            this.ocrResultMap[url].warnInfos = ocrResult ? ocrResult.warn_infos : ''
            this.ocrResultMap[url].imageStatus = ocrResult ? ocrResult.image_status : ''
            this.ocrResultMap[url].riskType = ocrResult ? ocrResult.risk_type : ''
            this.ocrResultMap[url].editTool = ocrResult ? ocrResult.edit_tool : ''
            this.ocrResultMap[url].isUseError = result.aiFlag ? '1' : '0'
        }

        if (url !== 'delegateFileUrl') {
            this.uploadForm[url] = responseData.downUrl
        }
        this.fileObj[url] = responseData
        // 设置文件上传成功返回的数据
        this.setResponseFormData(responseData, name, url, id, !!result.data.ocrResult)
        // if (ocrResult) {
            switch (name) {
            case 'idCardFileName':
                // 设置身份证正面带出的数据
                this.setIdCardFileFormData(ocrResult||{})
                break
            case 'idCardBottomSideFileName':
                // 设置身份证背面带出的数据
                this.setIdCardBottomSideFileFormData(ocrResult||{})
                break
            case 'drivingLicenceFileName':
                this.setDrivingLicenceFileFormData(ocrResult||{})
                break
            case 'empCertificateFileName':
                //从业资格证
                this.setEmpCertificateFileFormData(ocrResult||{})
                break
            default:
                break
            }
            // 如果身份证号存在，查询系统数据库中是否有关联司机信息
            if (ocrResult && ocrResult.idNumber && name === 'idCardFileName') {
                this.handleBlurIdCard(true)
            }
        // }
    },
    // 将上传文件后的回调数据(文件名、文件id、文件url)保存到formData中
    setResponseFormData(data, name, url, id, isOcr) {
        let fileName = data.localFileName
        // ocr识别的文件名添加后缀
        if (isOcr) {
            fileName = fileName + data.downUrl.slice(data.downUrl.lastIndexOf('.'))
        }
        this.$set(this.formData, name, fileName)
        this.$set(this.formData, url, data.downUrl)
        this.$set(this.formData, id, data.id)
        //当有异常标识时,重新上传完文件需要把异常标识清空
        this.showAbnormalFlag[url] = false
    },
    setOcrAndChangeType(prop, value, type){
        if(this.ocrResultMap[prop]){
            this.ocrResultMap[prop][type] = value
        }
    },
    // 设置上传身份证正面后带出来的数据
    setIdCardFileFormData(info) {
        // 新增时才允许编辑司机姓名和身份证号
        if (!this.id) {
            this.formData[idCardBringOutFieldsConfig[0].field] = info.name // 姓名
            this.formData[idCardBringOutFieldsConfig[1].field] = info.idNumber // 身份证号
            this.ocrCache.driverName = this.formData[idCardBringOutFieldsConfig[0].field]
            this.ocrData.driverName = this.formData[idCardBringOutFieldsConfig[0].field]
            this.ocrData.idCard = this.formData[idCardBringOutFieldsConfig[1].field]
        }
        //新增编辑都要把姓名和身份证号ocrValue存起来
        this.setOcrAndChangeType(idCardBringOutFieldsConfig[0].field, info.name, 'ocrValue')
        this.setOcrAndChangeType(idCardBringOutFieldsConfig[1].field, info.idNumber, 'ocrValue')

        this.formData[idCardBringOutFieldsConfig[2].field] = info.address // 详细地址
        this.setOcrAndChangeType(idCardBringOutFieldsConfig[2].field, info.address, 'ocrValue')

        this.ocrCache.familyAddress = info.address
        idCardBringOutFieldsConfig.forEach((e, i) => {
            if (i > 2) {
                switch (e.type) {
                case 'text':
                    if (this.formData[e.field] !== this.driverInfo[e.field]) {
                        this.formData[e.field] = info[e.field] || ''
                        this.setOcrAndChangeType(e.field, info[e.field], 'ocrValue')
                    }
                    break
                case 'date':
                    if (this.formData[e.field] !== this.driverInfo[e.field]) {
                        this.formData[e.field] = verifyDate(info[e.field])
                        this.setOcrAndChangeType(e.field, verifyDate(info[e.field]), 'ocrValue')
                    }
                    break
                }
            }
        })
        this.uploadForm.empCertificateFileUrl = this.formData.empCertificateFileUrl
        this.fileObj.empCertificateFileUrl = this.formData.empCertificateFileUrl
        //清空从业资格证异常标识提示
        this.showAbnormalFlag.empCertificateFileUrl = false
    },
    // 设置上传身份证反面后带出来的数据
    setIdCardBottomSideFileFormData(info) {
        this.formData.authorityIssue = info.issueAuthority
        this.formData.idCardStartDate = verifyDate(info.idCardStartTime)
        this.setOcrAndChangeType('idCardStartDate', this.formData.idCardStartDate, 'ocrValue')
        this.formData.idCardEndDate
            = info.idCardEndTime === '长期' ? '2099-12-31' : this.transformErrorMonth(verifyDate(info.idCardEndTime))
        this.setOcrAndChangeType('idCardEndDate', this.formData.idCardEndDate, 'ocrValue')
        this.ocrData.idCardEndDate = this.formData.idCardEndDate
    },
    //从业资格证
    setEmpCertificateFileFormData(info){
        this.formData.empCertificate = info.empCertificate
        this.setOcrAndChangeType('empCertificate', this.formData.empCertificate, 'ocrValue')
        // if(info.empCertificateType){
        //     const arr = info.empCertificateType.split(',')
        //     //从业资格证命中字典才赋值
        //     this.formData.empCertificateType = arr.reduce((t,v) => {
        //         if(this.dict['EMP_CERTIFICATE_TYPE'][v]){
        //             t.push(v)
        //         }
        //         return t
        //     }, [])
        //     this.setOcrAndChangeType('empCertificateType', this.formData.empCertificateType.join(','), 'ocrValue')
        // }else{
        //     this.formData.empCertificateType = []
        //     this.setOcrAndChangeType('empCertificateType', '', 'ocrValue')
        // }
        this.formData.empCertificateType = info.empCertificateType
        this.setOcrAndChangeType('empCertificateType', info.empCertificateType, 'ocrValue')
        this.formData.empCertificateEndDate = this.transformErrorMonth(verifyDate(info.empCertificateEndDate))
        this.setOcrAndChangeType('empCertificateEndDate', this.formData.empCertificateEndDate, 'ocrValue')
    },
    // 设置上传驾驶证后带出来的数据
    setDrivingLicenceFileFormData(info) {
        this.formData.sex = info.sex === '男' ? '1' : info.sex === '女' ? '2' : '' // ocr返回男女字符串，前端转为数字字典1，2
        this.formData.drivingLicence = info.mainNumber
        this.setOcrAndChangeType('drivingLicence',info.mainNumber, 'ocrValue')
        this.formData.driverLicenseAuthority = info.belongToPolice
        this.setOcrAndChangeType('driverLicenseAuthority',info.belongToPolice, 'ocrValue')
        
        this.formData.driveType = info.drivetype
        this.setOcrAndChangeType('driveType',info.drivetype, 'ocrValue')
        this.formData.mainNationality = info.mainNationality
        this.formData.dateIssue = verifyDate(info.issueDate)
        this.setOcrAndChangeType('dateIssue',this.formData.dateIssue, 'ocrValue')
        this.formData.driveStartDate = this.transformErrorMonth(verifyDate(info.validFrom))
        this.setOcrAndChangeType('driveStartDate',this.formData.driveStartDate, 'ocrValue')
        this.formData.driveEndDate
            = info.validTo === '长期' ? DATE_FOREVER : this.transformErrorMonth(verifyDate(info.validTo))
        this.setOcrAndChangeType('driveEndDate',this.formData.driveEndDate, 'ocrValue')
        this.ocrData.driveType = this.formData.driveType
        this.ocrData.driveStartDate = this.formData.driveStartDate
        this.ocrData.driveEndDate = this.formData.driveEndDate
        this.ocrData.drivingLicence = this.formData.drivingLicence
    },
    // 处理月份识别错误问题
    transformErrorMonth(dateStr) {
        let newDateStr = ''
        if (dateStr) {
            const dateArr = dateStr.split('-')
            if (dateArr.length && Number(dateArr[1]) > 12) {
                dateArr[1] = '12'
                newDateStr = dateArr.join('-')
            } else {
                newDateStr = dateStr
            }
        }
        return newDateStr
    },
    // 显示示例图片（继承旧版方法）
    showpopover(example) {
        this.$emit('show-popover', example)
    },
    // 输入身份证，若系统数据库中存在关联司机信息，则带出；fromOcr 判断是否通过附件上传ocr识别触发
    handleBlurIdCard(fromOcr) {
        let searchedIdCard = ''
        if (this.formData.idCard) {
            this.formData.idCard = this.formData.idCard.toUpperCase()
        }
        if (this.searchedIdCard) {
            const newSearchedIdCard = this.searchedIdCard + ''
            searchedIdCard = newSearchedIdCard.toUpperCase()
        }

        // 编辑时，或输入身份证号与上次相同时，都不进行查询
        if (this.id || this.formData.idCard === searchedIdCard) {
            return false
        }
        if (this.formData.idCard) {
            queryDriverInfo({ idCard: this.formData.idCard }).then(res => {
                if (res && +res.code === 0) {
                    // // 如果系统数据库中存在该司机信息，且身份证是有效的，显示提示语`司机信息已存在系统中，可以查看确定是否直接使用`
                    // this.isExistDriverInfo = !!res.data.idCard && res.data.idCardFlag === '0';
                    this.driverInfo = dealWithSearchResultParams(res.data)
                    if (this.driverInfo.idCard) {
                        this.driverInfo.idCard = this.driverInfo.idCard.toUpperCase()
                    }
                    Object.keys(this.formData).forEach(key => {
                        // 身份证、身份证证件字段有值才覆盖，其他字段不判断是否有值
                        if (['idCard'].includes(key)) {
                            if (this.driverInfo[key]) {
                                this.formData[key] = this.driverInfo[key]
                            }
                        } else if(['idCardFileId', 'idCardFileName', 'idCardFileUrl'].includes(key) && fromOcr){
                            if (this.driverInfo[key]) {
                                this.formData[key] = this.driverInfo[key]
                            }
                        }
                        else if (['empCertificateType'].includes(key)) {
                            // this.formData[key] = this.driverInfo[key] ? this.driverInfo[key].split(',') : []
                            this.formData[key] = this.driverInfo[key]
                            this.setOcrAndChangeType(key, this.formData[key], 'systemValue')
                        } else if (
                            [
                                'delegateOnline',
                                'delegateFileId',
                                'delegateFileName',
                                'delegateFileUrl',
                                'delegateStartTime',
                                'delegateEndTime',
                                'stamperCode',
                                'stamperMobile',
                                'pushType',
                            ].includes(key)
                        ) {
                            // 委派函相关字段不作覆盖
                            return false
                        } else if(['idCardBottomSideFileUrl', 'idCardBottomSideFileId', 'idCardBottomSideFileName', 'idCardStartDate', 'idCardEndDate', 'drivingLicenceFileId', 'drivingLicenceFileUrl', 'drivingLicenceFileName', 'drivingLicence', 'driveType', 'driveStartDate', 'driveEndDate', 'dateIssue', 'driverLicenseAuthority'].includes(key)){
                            /**
                             * 取消国徽/驾驶证信息覆盖
                             * // b-1、国徽页信息：国徽页图片、身份证起始日期、身份证到期日期
                            // b-2、驾驶证信息：驾驶证图片、准驾车型、驾驶证号、驾驶证起始日期、驾驶证到期日期、驾驶证初次领证日期、驾驶证签发机关。
                             */
                            return false
                        }else if (['idCardFileId', 'idCardFileName', 'idCardFileUrl', 'familyAddress', 'driverName'].includes(key) && !fromOcr) {
                            //手动输入身份证号时，身份证人像面/司机姓名/详细地址无需覆盖
                            return false
                        }
                        else if (fromOcr && ['driverName', 'familyAddress'].includes(key)) {
                            // 通过OCR上传后，若查询该司机数据为空，就使用OCR识别的数据覆盖
                            this.formData[key] = this.driverInfo[key] || this.ocrCache[key]
                            if(this.driverInfo[key]){
                                this.setOcrAndChangeType(key, this.driverInfo[key], 'systemValue')
                            }else if(this.ocrCache[key]){
                                this.setOcrAndChangeType(key, this.ocrCache[key], 'ocrValue')
                            }
                        } else if (
                            !this.id
                            && ['onWayContactCategory', 'onWayContactName', 'onWayContactPhone'].includes(key)
                        ) {
                            // 新增操作时，在途联系人有值才覆盖
                            if (this.driverInfo[key]) {
                                this.formData[key] = this.driverInfo[key]
                                this.setOcrAndChangeType(key, this.driverInfo[key], 'systemValue')
                            }
                        } else {
                            this.formData[key] = this.driverInfo[key]
                            this.setOcrAndChangeType(key, this.driverInfo[key], 'systemValue')
                        }
                    })
                    Object.keys(this.uploadForm).forEach(key => {
                        this.uploadForm[key] = this.formData[key]
                    })
                    this.setFileData(this.formData)
                    // this.setPrivinceCityOptions()
                    //清空联系地址--国家、省、市
                    ;['countryCode', 'countryName', 'provinceCode', 'provinceName', 'cityCode', 'cityName'].forEach(k => {
                        this.formData[k] = ''
                    })
                    this.searchedIdCard = this.formData.idCard
                }
            })
        }
    },
    // // 点击查看司机信息面板
    // handleViewDriverInfoPanel() {
    //     this.$refs.driverInfoModalRef.visible = true;
    // },
    // handleSetFormData() {
    //     Object.keys(this.driverInfo).forEach(k => {
    //         this.formData[k] = this.driverInfo[k] || '';
    //     });
    //     this.setFileData(this.driverInfo);
    //     this.isExistDriverInfo = false;
    // },
    // 预览文件（继承旧版方法）
    previewFile(flag) {
        let allAttachmentList = []
        const rowData = {}
        Object.keys(this.uploadForm).forEach(k => {
            allAttachmentList.push(this.uploadForm[k] ? this.uploadForm[k] : this.imgExample[k])
        })
        if (flag === 'delegateFileUrl') {
            rowData.fileId = this.formData.delegateFileId
            rowData.localFileName = this.formData.delegateFileName
            rowData.downUrl = this.formData.delegateFileUrl
            allAttachmentList = [rowData.downUrl].concat(allAttachmentList)
        } else {
            rowData.fileId = this.fileObj[flag] ? this.fileObj[flag].id : String(new Date().getTime())
            rowData.localFileName = this.fileObj[flag]
                ? this.fileObj[flag].localFileName
                : new Date().getTime() + '_' + flag
            rowData.downUrl = this.fileObj[flag] ? this.fileObj[flag].downUrl : this.imgExample[flag]
        }
        this.$emit('preview', { allAttachmentList, rowData })
    },
    // 下载模板（继承旧版方法）
    handleDownloadTemplate(fileName, localFileName, type) {
        this.$emit('download', fileName, localFileName, type)
    },
    // 处理请求参数
    dealWithReqParams() {
        const isSupplier = this.supplier
        const supplierCode = isSupplier ? isSupplier.supplierCode : this.$route.query.supplierCode
        const formData = JSON.parse(JSON.stringify(this.formData))
        // 240509司机注册需求，若系统查出该司机，新增也需要传司机编码
        // formData.driverCode = formData.driverId ? formData.driverCode : ''; // 新增不用传司机编码
        formData.supplierCode = supplierCode
        formData.drivingLicence = formData.drivingLicence.toUpperCase()
        // if (!this.isLegalPersonSupplier) {
            formData.countryName = this.getAddressName(formData.countryCode, 'country')
            formData.provinceName = this.getAddressName(formData.provinceCode, 'province')
            formData.cityName = this.getAddressName(formData.cityCode, 'city')
        // }
        // formData.empCertificateType = formData.empCertificateType.length ? formData.empCertificateType.join(',') : ''
        // 来源渠道
        formData.createSystemSource = isSupplier ? REGISTER_SOURCE.LSP : REGISTER_SOURCE.LSRM
        formData.businessType = this.supplierTab.businessType || null
        //增加改变方式入参
        
        formData.paramFieldList = Object.keys(this.ocrResultMap).map(k => {
            // const beforeValue = k === 'empCertificateType' ? (this.backupFormData[k] + '') : this.backupFormData[k]
            const beforeValue = this.backupFormData[k]
            return {...this.ocrResultMap[k], beforeValue: this.id ? beforeValue : ''}
        })
        return formData
    },
    setChangeType(){
        //提交时需要对比前后值的变化 changeType: 1-ocr,2-system,3-人工
        Object.keys(this.ocrResultMap).forEach(k => {
            // if(k === 'empCertificateType'){
            //     const isSame = this.backupFormData[k].length === this.formData[k].length && this.backupFormData[k].every((item, idx) => this.formData[k].includes(item))
            //     if(['30', '80'].includes(this.backupFormData.approvalStatus) && isSame){
            //         //如果是撤回/驳回状态并且值没有变化，那么不用设置changeType,用初始化的值
            //         if(this.ocrResultMap[k].changeType === '3'){
            //             //如果是人工，需要避免卡控
            //             this.ocrResultMap[k].noCheck = true
            //         }
            //         return
            //     }


            //     if(this.ocrResultMap[k].ocrValue){
            //         //有OCR识别结果
            //         const ocrValue = this.ocrResultMap[k].ocrValue.split(',')
            //         if(ocrValue.length === this.formData[k].length && ocrValue.every((item, idx) => this.formData[k].includes(item))){
            //             this.ocrResultMap[k].changeType = '1'
            //         }else{
            //             this.ocrResultMap[k].changeType = '3'
            //             this.ocrResultMap[k].noCheck = false
            //         }
            //     }else{
            //         //没有OCR识别结果
            //         if(this.backupFormData[k].length === this.formData[k].length && this.backupFormData[k].every((item, idx) => this.formData[k].includes(item))){
            //             this.ocrResultMap[k].changeType = '2'
            //         }else{
            //             this.ocrResultMap[k].changeType = '3'
            //             this.ocrResultMap[k].noCheck = false
            //         }
            //     }
            // }else{
                const isSame = (this.formData[k] == this.backupFormData[k]) || (this.isEmpty(this.formData[k]) && this.isEmpty(this.backupFormData[k]))
                if(['30', '80'].includes(this.backupFormData.approvalStatus) && isSame){
                    //如果是撤回/驳回状态并且值没有变化，那么不用设置changeType,用初始化的值
                    if(this.ocrResultMap[k].changeType === '3'){
                        //如果是人工，需要避免卡控
                        this.ocrResultMap[k].noCheck = true
                    }
                    return
                }



                if(this.ocrResultMap[k].ocrValue){
                    //如果有OCR识别结果
                    if(this.ocrResultMap[k].ocrValue == this.formData[k]){
                        //OCR值与表单值一致
                        this.ocrResultMap[k].changeType = '1'
                    }else{
                        this.ocrResultMap[k].changeType = '3'
                        this.ocrResultMap[k].noCheck = false
                    }
                }else{
                    //没有OCR识别结果
                    if((this.formData[k] == this.backupFormData[k]) || (this.isEmpty(this.formData[k]) && this.isEmpty(this.backupFormData[k]))){
                        //值相同，则把changeType改为system
                        this.ocrResultMap[k].changeType = '2'
                    }else if(this.ocrResultMap[k].systemValue){
                        //有system自动赋值过
                        if(this.ocrResultMap[k].systemValue == this.formData[k]){
                            //systemValue值与表单值一致
                            this.ocrResultMap[k].changeType = '2'
                        }else{
                            this.ocrResultMap[k].changeType = '3'
                            this.ocrResultMap[k].noCheck = false
                        }
                    }else{
                        //前后值不一致并且没有system赋值
                        this.ocrResultMap[k].changeType = '3'
                        this.ocrResultMap[k].noCheck = false
                    }
                }
            // }
        })
        //身份证人面像改变了
        if(this.formData.idCardFileUrl !== this.backupFormData.idCardFileUrl){
            //司机姓名和身份证号的ocrValue与表单值对比
            ['driverName', 'idCard'].forEach(k => {
                if(this.ocrResultMap[k].ocrValue === this.formData[k]){
                    //对比一致时，编辑属于system，新建属于ocr
                    this.ocrResultMap[k].changeType = this.id ? '2' : '1'
                }else{
                    //对比不一致时，编辑属于system高风险，新建属于人工高风险
                    this.ocrResultMap[k].changeType = this.id ? '4' : '5'
                }
            })
        }
        //驾驶证改变了
        if(this.formData.drivingLicenceFileUrl !== this.backupFormData.drivingLicenceFileUrl){
            //驾驶证号的ocrValue与表单值对比
            ['drivingLicence'].forEach(k => {
                if(this.ocrResultMap[k].ocrValue === this.formData[k]){
                    //对比一致时，属于ocr
                    this.ocrResultMap[k].changeType = '1'
                }else{
                    //对比不一致时，属于人工高风险
                    this.ocrResultMap[k].changeType = '5'
                }
            })
        }
        if(this.formData.delegateOnline !== this.backupFormData.delegateOnline){
            //委派函类型不一致,则委派函时间肯定属于人工改变
            this.ocrResultMap.delegateStartTime.changeType = '3'
            this.ocrResultMap.delegateEndTime.changeType = '3'
        }
    },
    // 校验表单
    validateForm(fn) {
        if (!this.formData.idCardFileUrl) {
            return this.$message.warning('请上传身份证(人像面)')
        } else if (!this.formData.idCardBottomSideFileUrl) {
            return this.$message.warning('请上传身份证(国徽面)')
        } else if (!this.formData.drivingLicenceFileUrl) {
            return this.$message.warning('请上传驾驶证')
        } else if (!this.formData.empCertificateFileUrl && this.empCertificateRequired && this.empSwitch) {
            return this.$message.warning('请注意，准驾车型为A/B照司机必须上传从业资格证！')
        }
        Promise.resolve(this.$refs.formRef.validate())
            .then(async () => {
                this.setChangeType()
                if (!this.checkCredentialDate()) {
                    return false
                }
                const checkReq = this.formData.driverCode ? checkDriverIsExistsByEdit : checkDriverIsExists
                this.$parent.$parent.loading = true
                const phoneValidRes = await checkReq({
                    idCard: this.formData.idCard,
                    phoneNo: this.formData.phoneNo,
                    driverCode: this.formData.driverCode,
                }).catch(err => {})
                if (!phoneValidRes || +phoneValidRes.code !== 0) {
                    return false
                }
                this.$parent.$parent.loading = false

                // 非物流供应商 || ocr数据有改动 || 是法人且线下委派函 || 非法人且委派函字段有值 || 审批状态不是通过 || 手机号码被使用
                const needExamine =
                    this.supplierTab.supplierType !== LOGISTICS_SUPPLIER ||
                    (this.isLegalPersonSupplier && this.formData.delegateOnline === DELEGATE_TYPE.OFFLINE) ||
                    (!this.isLegalPersonSupplier
                        && (!!this.formData.delegateFileName
                            || !!this.formData.delegateStartTime
                            || !!this.formData.delegateEndTime)) ||
                    Object.keys(this.ocrData).some(key => this.ocrData[key] !== this.formData[key]) ||
                    (this.approvalStatus && this.approvalStatus !== AUDIT_STATUS.ADOPT) ||
                    phoneValidRes.data
                // 是物流供应商，且是线上委派函，且ocr数据有改动，提示信息
                const needAudit
                    = this.supplierTab.supplierType === LOGISTICS_SUPPLIER
                    && this.formData.delegateOnline === DELEGATE_TYPE.ONLINE &&
                    Object.keys(this.ocrData).some(key => this.ocrData[key] !== this.formData[key])
                // 系统带出手机号与当前提交的手机号作对比 TODO: 0509先不上，6月份后续再上
                // const phoneTip = this.driverInfo.phoneNo && this.driverInfo.phoneNo !== this.formData.phoneNo ? '您修改了司机手机号码，该司机在其他关联法人供应商下将停用，且须重新签署司机委派函才能启用。<br />' : ''

                const tipsArr = []
                if (needAudit) {
                    // tipsArr.push('♦ 您修改了身份证、驾驶证信息，需提交审批。')
                }
                if (phoneValidRes.data) {
                    tipsArr.push('♦ 该手机号码已被其他司机司机使用，如确认修改，则其他司机将被停用和清空手机号。')
                }
                // 通过 idCard 来判断是否有查出司机数据或编辑时详情接口返回司机数据，再将司机手机号和现填手机号作对比
                if (this.driverInfo.idCard && this.driverInfo.phoneNo !== this.formData.phoneNo) {
                    tipsArr.push('♦ 您修改了手机号码，司机和法人供应商之间需重新签委派函。')
                }

                if (tipsArr.length) {
                    const tipsStr = tipsArr.join('<br />') + '<br /><br />是否继续执行修改？'
                    this.$confirm(tipsStr, '提示', {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: '确认修改',
                        cancelButtonText: '取消',
                        type: 'info',
                    })
                        .then(() => {
                            fn(this.dealWithReqParams(), needExamine)
                        })
                        .catch(() => {})
                } else {
                    fn(this.dealWithReqParams(), needExamine)
                }
            })
            .catch(err => {
                this.$message.warning('必填项未维护完整，请仔细检查')
            })
    },
    isEmpty(v){
        return ['', undefined, null].includes(v)
    },
    // 校验证件有效期被修改了，但附件未重新上传
    checkCredentialDate() {
        // let flag = true
        // const credentialNames = []
        // if (
        //     (this.driverInfo.idCardStartDate !== this.formData.idCardStartDate ||
        //         this.driverInfo.idCardEndDate !== this.formData.idCardEndDate) &&
        //     this.driverInfo.idCardBottomSideFileUrl === this.formData.idCardBottomSideFileUrl
        // ) {
        //     credentialNames.push('身份证(国徽面)')
        // }
        // if (
        //     (this.driverInfo.driveStartDate !== this.formData.driveStartDate ||
        //         this.driverInfo.driveEndDate !== this.formData.driveEndDate) &&
        //     this.driverInfo.drivingLicenceFileUrl === this.formData.drivingLicenceFileUrl
        // ) {
        //     credentialNames.push('驾驶证')
        // }
        // if (credentialNames.length) {
        //     this.$message.warning(`您修改了${credentialNames.join('、')}有效期，请重新上传证件图片。`)
        //     flag = false
        // }
        // return flag
        let flag = true
        let licenseNameList = []
        //针对特定OCR字段，如果人工修改后没有重新上传对应的证件图片，需要卡控
        const validateList = this.validateOcrData.reduce((t, v) => {
            if(this.ocrResultMap[v.field].changeType === '3' && !this.ocrResultMap[v.field].noCheck && (this.backupFormData[v.fileProp] === this.formData[v.fileProp] || (this.isEmpty(this.backupFormData[v.fileProp]) && this.isEmpty(this.formData[v.fileProp])))){
                console.log('修改前：',this.backupFormData[v.field],'修改后：',this.formData[v.field],'修改前url：',this.backupFormData[v.fileProp],'修改后url：',this.formData[v.fileProp],'字段：',v.label)
                //从业资格证非必填时资格证相关字段修改后无需重传证件
                if((this.empCertificateRequired && ['empCertificateEndDate','empCertificate','empCertificateType'].includes(v.field)) || !['empCertificateEndDate','empCertificate','empCertificateType'].includes(v.field)){
                    t.push(v.label)
                    licenseNameList.push(v.licenseName)
                }
            }
            return t
        }, [])
        if(validateList.length){
            this.$message.warning(`您修改了${validateList.join('、')}，请重新上传${[...new Set(licenseNameList)].join('、')}。`)
            flag = false
        }
        return flag
    },
    // 重置表单
    resetForm() {
        if (this.$refs.formRef) {
            this.$refs.formRef.resetFields()
            // this.isExistDriverInfo = false;
            this.driverInfo = {}
            this.fileObj = {}
            ;['idCardFileUrl', 'idCardBottomSideFileUrl', 'drivingLicenceFileUrl', 'empCertificateFileUrl'].forEach(
                k => (this.uploadForm[k] = ''),
            )
            Object.keys(this.formData).forEach(k => {
                if (k === 'delegateOnline') {
                    return
                }
                // if (['empCertificateType'].includes(k)) {
                //     this.formData[k] = []
                //     return
                // }
                this.formData[k] = ''
            })
            this.delegateOnline = ''
            this.formData.delegateOnline = this.isLegalPersonSupplier ? DELEGATE_TYPE.ONLINE : DELEGATE_TYPE.OFFLINE
            this.searchedIdCard = ''
            this.ocrCache = {
                driverName: null,
                familyAddress: null,
            }
        }
    },
    getAddressName(val, key) {
        let result = ''
        this[key + 'Options'].forEach(e => {
            if (val === e.value) {
                result = e.label
            }
        })
        return result
    },
    handleAdressSelect(val, key, clearChild = true) {
        if (!val) {
            return false
        }
        if (key === 'country') {
            this.provinceOptions = []
            this.cityOptions = []
            getProvinces(val).then(res => {
                this.provinceOptions = [].concat(res)
                if (clearChild) {
                    this.$set(this.formData, 'provinceCode', '')
                    this.$set(this.formData, 'cityCode', '')
                }
            })
        } else if (key === 'province') {
            if (!this.formData.countryCode) {
                this.$message.warning('请选择国家')
                this.$set(this.formData, 'provinceCode', '')
            } else {
                this.cityOptions = []
                getCitys(val).then(res => {
                    this.cityOptions = [].concat(res)
                    if (clearChild) {
                        this.$set(this.formData, 'cityCode', '')
                    }
                })
            }
        } else if (key === 'city') {
            if (!this.formData.provinceCode || !this.formData.countryCode) {
                this.$message.warning('请选择国家和省份')
                this.$set(this.formData, 'cityCode', '')
            }
        }
    },
    // 设置委派函线下选项是否可见
    setDelegateOlVisible() {
        const supplierCode = this.$store.state.supplier
            ? this.$store.state.supplier.supplierCode
            : this.$route.query.supplierCode
        checkSupplierIsWhite({ supplierCode })
            .then(res => {
                if (res && +res.code === 0) {
                    this.delegateVisible = res.data
                    // 当不在白名单是data返回false，委派函已选为线下的，重设为线上
                    if (res.data === false && this.formData.delegateOnline === DELEGATE_TYPE.OFFLINE) {
                        this.formData.delegateOnline = DELEGATE_TYPE.ONLINE
                        this.radioChange(DELEGATE_TYPE.ONLINE)
                    }
                }
            })
            .catch(err => {})
    },
    // 设置省份、城市下拉选项
    setPrivinceCityOptions() {
        if (this.formData.countryCode) {
            this.handleAdressSelect(this.formData.countryCode, 'country', false)
        }
        if (this.formData.provinceCode) {
            this.handleAdressSelect(this.formData.provinceCode, 'province', false)
        }
    },
    getOwcnAdvanceValue(val) {
        this.formData.onWayContactName = val.onWayContactName
        this.formData.onWayContactPhone = val.onWayContactPhone
    },
    setOnWayContact(type) {
        const params = {
            supplierCode: this.supplierTab.supplierCode,
            pageNo: 1,
            pageSize: 10,
        }
        getOnWayContacts(params).then(res => {
            if (res && +res.code === 0) {
                this.formData.onWayContactName
                    = res.data.list && res.data.list.length === 1 ? res.data.list[0].contacts : ''
                    if(type === 'system'){
                        this.setOcrAndChangeType('onWayContactName', this.formData.onWayContactName, 'systemValue')
                    }

                this.formData.onWayContactPhone
                    = res.data.list && res.data.list.length === 1 ? res.data.list[0].contactsMobile : ''
                    if(type === 'system'){
                        this.setOcrAndChangeType('onWayContactName', this.formData.onWayContactPhone, 'systemValue')
                    }

            }
        })
    },
}
